import { useEffect, useRef } from 'react'
import { Product } from '@/types'
import ProductHelpers from '@/helpers/Product'
import { Listrak } from '@/services'
import { BigCommerceCart } from '@/types/Cart'

export const useListrakProductTracking = (product: Product, sku: string) => {
  const collectionVariants = ProductHelpers.getCollectionVariants(product)

  useEffect(() => {
    if (!product.options.length && !collectionVariants.length) {
      Listrak.listrakProductBrowse(sku)
    }
  }, [sku, product, collectionVariants])
}

export const useListrakCartTracking = (cart: BigCommerceCart | null) => {
  const cartRef = useRef(cart)
  useEffect(() => {
    try {
      if (cart) {
        if (cartRef.current) {
          if (!areCartItemsSame(cart, cartRef.current)) {
            Listrak.submitCart(cart)
          }
        } else {
          Listrak.submitCart(cart)
        }
      } else {
        if (cartRef.current) {
          Listrak.listrakEmptyCart()
        }
      }
    } catch (e) {
    } finally {
      cartRef.current = cart
    }
  }, [cart])
}

function areCartItemsSame (cart1: BigCommerceCart, cart2: BigCommerceCart): boolean {
  if (cart1.lineItems.physicalItems.length !== cart2.lineItems.physicalItems.length) {
    return false
  }

  const cart1SkuQuantity = new Set(cart1.lineItems.physicalItems.map(item => JSON.stringify([item.sku, item.quantity])))
  const cart2SkuQuantity = new Set(cart2.lineItems.physicalItems.map(item => JSON.stringify([item.sku, item.quantity])))
  for (const item of cart1SkuQuantity) {
    if (!cart2SkuQuantity.has(item)) {
      return false
    }
  }
  return true
}
